module.exports = __webpack_public_path__ + "img/not-authorized.85457726.svg";